import { render, staticRenderFns } from "./SettingsVatProductRow.vue?vue&type=template&id=4eb5b19c&"
import script from "./SettingsVatProductRow.vue?vue&type=script&lang=js&"
export * from "./SettingsVatProductRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports